/**
 * BOOKING component
 *   @Input() segmentItem: any; // segment Item
 *   @Input() ar: string;       // Aller/retour string
 *   @Input() type: string;     // default / sectorList / journeyList
 **/
import { Component, Input } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import { faArrowRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";

declare var wenji:any;

//service
import { DateService } from 'libraries/date/date.service';

@Component({

    selector: 'abstractItineraryCard',
    templateUrl: './abstractItineraryCard.component.html',
    styleUrls: ['./abstractItineraryCard.component.scss']
})
export class AbstractItineraryCardComponent {
    public Yii = Yii;
    public dateFormat = JSON.parse(wenji.ui.dateFormat);
    @Input() public itinerary: any;
    @Input() public bookingItem: any;
    @Input() public selectedJourneys: string[] = [];
    @Input() public separator: string;
    @Input() public price: any;
    @Input() public carrier: any;
    @Input() public isOthersFlights: boolean = false;
    @Input() public selectedFlight: boolean;

  public dayDiff: string[];

  public iconArrowRight: IconDefinition = faArrowRight;

  constructor(private dateService: DateService) {}

  public getDayDiff(_begin: any ,_end: any): any{
          return this.dateService.dayDifference(_begin ,_end);
  }

}
